const parseBoolean = value => value === true || value === 'true';

export const isRestrictedAgentAccessEnabled = () => {
  return parseBoolean(window.chatwootConfig?.restrictedAgentAccessEnabled);
};

export const getUserAccount = ({ user, accountId } = {}) => {
  const accounts = Array.isArray(user?.accounts) ? user.accounts : [];

  return accounts.find(account => Number(account.id) === Number(accountId));
};

export const isRestrictedAgent = ({ user, accountId } = {}) => {
  if (!isRestrictedAgentAccessEnabled()) return false;

  const account = getUserAccount({ user, accountId });

  // Com a flag ativa, somente administrator permanece irrestrito.
  // Conta ausente, papel desconhecido e custom roles ficam restritos.
  return account?.role !== 'administrator';
};
